/*
    node_js
    2/22/2021 7:39 PM
    by Oleksandr
*/

import CWP from "./cwp/CWP";
import ATG from "./atg/ATG";

const EPP = () => {
    return (
        <>
            <CWP isEpp={true}/>
            <ATG/>
        </>
    )
}

export default EPP;